export const TYPES = {
  blockQuote: "quote_block",
  document: "doc",
  hardBreak: "hard_break",
  heading: "headings_block",
  imageBlock: "image_block",
  ignoreBlock: "ignore_block",
  keyTerm: "keyTerm_block",
  orderedList: "orderedList_block_0",
  orderedListItem: "orderedList_block_1",
  paragraph: "paragraph",
  powerWord: "powerWord_block",
  preformatted: "pre_block",
  text: "text",
  unorderedList: "list_block_0",
  unorderedListItem: "list_block_1",
};

export const elementMap = {
  [TYPES.blockQuote]: "blockquote",
  [TYPES.heading]: "h",
  [TYPES.keyTerm]: "span",
  [TYPES.orderedListItem]: "li",
  [TYPES.orderedList]: "ol",
  [TYPES.paragraph]: "p",
  [TYPES.powerWord]: "span",
  [TYPES.preformatted]: "pre",
  [TYPES.text]: "",
  [TYPES.unorderedListItem]: "li",
  [TYPES.unorderedList]: "ul",
  // The Read page wraps images in paragraph tags.
  [TYPES.imageBlock]: "p",
};
